import { render, staticRenderFns } from "./dialogLoader.vue?vue&type=template&id=80b42832&scoped=true"
import script from "./dialogLoader.vue?vue&type=script&lang=js"
export * from "./dialogLoader.vue?vue&type=script&lang=js"
import style0 from "./dialogLoader.vue?vue&type=style&index=0&id=80b42832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b42832",
  null
  
)

export default component.exports